const SERVICE = 'partner-service'

const getPartnerListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/partner', params)

const getPartnerApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/admin/partner/${id}`)

const createPartnerApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/partner')

const updatePartnerApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/partner/${id}`)

const deletePartnerApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/partner/${id}`)

// for doctor/patient app
const getPartnerDataApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/key', params)

module.exports = {
  getPartnerListApi,
  getPartnerApi,
  createPartnerApi,
  updatePartnerApi,
  deletePartnerApi,

  // for doctor/patient app
  getPartnerDataApi,
}
